<template>
	<div class="container">
		<img src="@/assets/add_teacher.png" class="add-teacher" />
		<div class="content">
			<div class="info">
				<img src="@/assets/success.png" class="success" />
				<div class="tip">恭喜你成功抢购课程</div>
			</div>
			<div class="info-sum">
				<div class="activation">
					长按添加你的专属班主任，激活课程服务
				</div>
				<img :src="qrcode" style="width: 140px;" />
				<!-- <div class="add" @click="goWeixin">立即添加</div> -->
				<img src="@/assets/answering.png" class="answering" />
			</div>
		</div>


		<!-- 中层弹出 -->
		<div v-if="phoneShow">
			<div class="popup_mengceng"></div>
			<div class="modals">
				<div class="modals_1">
					<span>还差一步</span>
					<div class="cuo" @click="phoneShow = false">×</div>
				</div>
				<div class="modals_2">
					<div class="title">请填写报名信息</div>
					<div class="form-item">
						<div class="label">学员姓名</div>
						<input type="text" placeholder="请输入您的姓名" v-model="form.name" class="input" />
					</div>
					<div class="form-item">
						<div class="label">手机号码</div>
						<input type="tel" placeholder="请输入您的手机号" v-model="form.phone" maxlength="11" class="input" />
					</div>
					
				<div>
					<div class="txt_top">
						<img src="@/assets/tixing.png" class="tixing_img" />
						<div class="tixing">手机号是支付成功的<span class="tixing-txt">唯一凭证</span></div>
					</div>
					<div class="txt_bottom">请立即完成填写!</div>
				</div>
				</div>
				<div class="modals_3" @click="submit()">提交</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant';
export default {
	name: 'LoginIndex',
	components: {},
	props: {},
	data() {
		return {
			url: '',
			userId: '',
			orderId: '',
			qrcode: '',
			customerObj: '',
			phoneShow: false,
			form: {
				name: '',
				phone: ''
			},
		}
	},
	computed: {},
	watch: {},
	created() {
        document.title = '报名成功';
		this.orderId = this.$route.query.orderId || '';
		this.getUsers()
	},
	methods: {
		getUsers() {
			this.$http.get('/app/users/current', {}).then(res => {
				this.userId = res.data.id;
				this.qrcode = res.data.teacher.qrcode;
				this.form.name = res.data.realName;
				if (res.data.phone == null || res.data.phone == '') {
					this.phoneShow = true;
				}
			})
		},

		submit() {
			this.$http.post('/app/users/bindPhone', {
				orderId: this.orderId,
				name: this.form.name,
				phone: this.form.phone
			}).then(res => {
				this.phoneShow = false;
				this.$toast('提交成功,快去添加老师吧')
			})
		},

		goWeixin() {
			// window.location.href = 'weixin://dl/business/?appid=wx2fa3691b1bc69740&path=pages/index/index&env_version=release'
			window.location.href = this.url || 'weixin://dl/business/?t=f4S6BOwGMtf'
		},

		getMaScheme() {
			this.$http.get('/app/channels/getMaScheme', {
				userId: this.userId
			}).then(res => {
				console.log("数据" + res)
				this.url = res.data
			})
		},

		//获取班主任详情
		getTeacher() {
			this.$http.get('/app/users/getTeacher', {
				id: this.userId
			}).then(res => {
				if (res.code == 200) {
					this.customerObj = res.data
					console.log("班主任详情" + this.customerObj)
				}
			})
		}
	}
}
</script>

<style scoped lang="less">
.modals {
	top: 25vh;
	left: 0;
	right: 0;
	width: 87%;
	padding: 50px;
	position: fixed;
	margin: 0 auto;
	z-index: 2002 !important;
	border-radius: 20px;
	background-color: #fff;

	.modals_1 { 
		font-size: 40px;
		font-weight: 700;
		text-align: center;
		color: red;
		position: relative;

		.cuo {
			position: absolute;
			top: -40px;
			right: -40px;
			font-size: 48px;
			color: #999;
			width: 50px;
			height: 50px;
			line-height: 50px;
		}
	}

	.modals_2 {
		margin: 60px 0;

		.title {
			font-size: 32px;
			font-weight: 700;
		}

		.form-item {
			display: flex;
			align-items: center;
			width: 100%;
			margin: 30px 0;

			.label {
				font-size: 28px;
				color: #666;
				margin-right: 20px;
				width: 160px;
			}

			.input {
				background-color: #f7f9fd;
				border-radius: 16px;
				border: 1px solid #f5f5f5;
				height: 80px;
				line-height: 80px;
				width: 96%;
				padding: 0 20px;
			}
		}

		.txt_top {
			display: flex;
			align-items: center;
			justify-content: center;

			.tixing_img {
				width: 48px;
				height: 48px;
			}
			.tixing {
				font-size: 32px;
				font-weight: bold;
				padding-left: 20px;

				.tixing-txt {
					font-size: 32px;
				    color: red;
					padding-left: 10px;
				}
			}
		}

		.txt_bottom {
		    font-size: 32px;
			font-weight: bold;
			padding-top: 20px;
			text-align: center;
		}
	} 

	.modals_3 {
		width: 100%;
			height: 76px;
			line-height: 76px;
			text-align: center;
			border-radius: 100px;
			font-size: 34px;
			color: #fff;
			font-weight: 700;
			background-color: red;
	}
}

.popup_mengceng {
	z-index: 2001;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, .7);
}

.container {
	font-size: 28px;
	color: #333;
	background: #1fcc78;
	height: 100vh;

	.content {
		padding: 32px;
		margin-top: -90px;
		position: relative;
	}

	.add-teacher {
		width: 100vw;
		// height: 370px;
	}

	.info {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		background: #fff7ed;
		border-radius: 40px 40px 0 0;
		height: 214px;

		.tip {
			font-size: 30px;
		}

		.success {
			width: 80px;
			height: 80px;
			margin-bottom: 16px;
		}
	}

	.info-sum {
		background: #fff;
		border-radius: 0 0 40px 40px;
		height: 654px;
		display: flex;
		flex-direction: column;
		// justify-content: center;
		align-items: center;

		.answering {
			width: 620px;
			// height: 220px;
		}

		.activation {
			font-size: 32px;
			font-weight: 700;
			padding: 66px 0 40px;
			text-align: center;
		}

		.add {
			width: 622px;
			height: 100px;
			background: #fb0;
			border-radius: 50px;
			display: block;
			line-height: 100px;
			text-align: center;
			font-size: 40px;
			color: #fff;
			font-weight: 700;
			outline: none;
			margin-bottom: 107px;
			-webkit-animation: fadenum 0.8s ease infinite;
			animation: fadenum 0.8s ease infinite;
		}
	}
}

@keyframes fadenum {
	0% {
		transform: scale(0.95);
		-webkit-transform: scale(0.95);
	}

	50% {
		transform: scale(1.02);
		-webkit-transform: scale(1.02);
	}

	100% {
		transform: scale(0.95);
		-webkit-transform: scale(0.95);
	}
}
</style>